import getResumeContactCity from '@glass/common/modules/resumes/selectors/getResumeContactCity';
import { selectResumeValue } from '@glass/web/modules/resumes/selectors';

import selectUserResumeCity from '@glass/shared/modules/userConfig/selectors/selectUserResumeCity';

const selectUserCity = (state) =>
  getResumeContactCity(selectResumeValue(state)) || selectUserResumeCity(state);

export default selectUserCity;
